import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import 'rc-dropdown/assets/index.css';
import { faCheck, faSearch } from '@fortawesome/pro-solid-svg-icons';


const Index = ({
  value,
  dropdownId,
  selectedId,
  setSelectedId,
  selectedName,
  setSelectedName,
  onChange
}) => {
  const [visible, setVisible] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchText, setSearchText] = useState('');

  const handleVisibleChange = (visible) => {
    setVisible(visible);
    if(visible)
    {
      searchHandler('');
    }
  };

  const handleChange = (event) => {
    if (event.key != -2) {
      if (onChange)
        onChange(event);

      if(setSelectedId) {
        setSelectedId(event.key);
        const selectedItem = value.filter((item) => item.id == event.key);
        if (selectedItem.length > 0)
          setSelectedName(selectedItem[0].name);
      }
    }
  };

  const searchHandler = (searchString) => {
    setSearchText(searchString);
    if (searchString.length === 0) {
      setSearchResults([]);
      return;
    }
    const searchResults = value.filter((item) =>
      item.name.toLowerCase().includes(searchString.toLowerCase())
    );
    if (searchResults.length === 0) {
      const noResults = [{ id: -2, name: 'No results found' }];
      setSearchResults(noResults);
      return;
    }
    setSearchResults(searchResults);
  };

  const menu = (
    <Menu className='w-100 folder-dropdown' onSelect={(e) => { handleChange(e); setVisible(false); }}>
      <div className="custom-search position-relative mb-3">
        <FontAwesomeIcon icon={faSearch} />
        <input type="text" value={searchText} onChange={(e) => searchHandler(e.target.value)} className="form-control" />
      </div>
      {searchResults.length > 0 ? (<>
        {searchResults.map((item, index) => (
          <MenuItem key={item.id} className={`${item.id == selectedId ? 'selected-value' : ''}`}>
            <div className='form-check d-flex justify-content-between align-items-center'>
              <div className="cursor-pointer">
                <div className={`${item.id === -2 ?'text-danger':''}`} htmlFor={'check-' + index}>
                  {item.name}{' '}
                </div>
              </div>
              {item.id == selectedId ? (
                <div className='px-3'>
                  <FontAwesomeIcon className='green-tick' icon={faCheck} />
                </div>
              ) :
                <div></div>
              }
            </div>
          </MenuItem>
        ))}
      </>) : <>
        {value?.map((item, index) => (
          <MenuItem key={item.id} className={`${item.id == selectedId ? 'selected-value' : ''}`}>
            <div className='form-check d-flex justify-content-between align-items-center'>
              <div className="cursor-pointer">
                <div htmlFor={'check-' + index}>
                  {item.name}{' '}
                </div>
              </div>
              {item.id == selectedId ? (
                <div className='px-3'>
                  <FontAwesomeIcon className='green-tick' icon={faCheck} />
                </div>
              ) :
                <div></div>
              }
            </div>
          </MenuItem>
        ))}
      </>}
    </Menu>
  );

  return (
    <>
      <div id={dropdownId}>
        <Dropdown
          trigger={['click']}
          onVisibleChange={handleVisibleChange}
          visible={visible}
          closeOnSelect={true}
          overlay={menu}
          overlayClassName='dropdown-style'
          animation="slide-up"
          getPopupContainer={() => document.getElementById(dropdownId)}>
          <div className="form-select d-flex align-items-center">
            <div value={selectedId} className={`form-placeholder cursor-pointer overflow-hidden ${selectedName?.length > 65 ? ' fs-7' : ''}`}>{selectedName}</div>
          </div>
        </Dropdown>
      </div>
    </>
  );
};

Index.propTypes = {
  value: PropTypes.array,
  dropdownId: PropTypes.string,
  selectedId: PropTypes.string,
  setSelectedId: PropTypes.func,
  selectedName: PropTypes.string,
  setSelectedName: PropTypes.func,
  onChange: PropTypes.func
};

export default Index;
